import { render } from "./CargosTableConfirm.vue?vue&type=template&id=4b52552a&scoped=true"
import script from "./CargosTableConfirm.vue?vue&type=script&lang=js"
export * from "./CargosTableConfirm.vue?vue&type=script&lang=js"

import "./CargosTableConfirm.vue?vue&type=style&index=0&id=4b52552a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b52552a"]])

export default __exports__